export default __webpack_public_path__ + "static/media/cloud_migration.a5a47977.svg";